import React from "react";
import { useI18n } from "../../../lib/i18n";
import KpiCard from "../shared/KpiCard";
import { Truck, Shield, Wallet, Calendar, Wrench, Gavel } from "lucide-react";

const CATEGORY_WIDGETS = {
  rental_company: (extras) => [
    ["fleet_size",           Truck,    "حجم الأسطول",       "Fleet size"],
    ["reservations",         Calendar, "الحجوزات",           "Reservations"],
    ["active_reservations",  Calendar, "الحجوزات النشطة",     "Active reservations"],
  ].map(([k, i, ar, en]) => ({ key: k, icon: i, ar, en, value: extras[k] })),

  insurance_company: (extras) => [
    ["requests",  Shield, "الطلبات الواردة",  "Requests"],
    ["approved",  Shield, "معتمَدة",           "Approved"],
    ["rejected",  Shield, "مرفوضة",            "Rejected"],
    ["products",  Shield, "المنتجات",          "Products"],
  ].map(([k, i, ar, en]) => ({ key: k, icon: i, ar, en, value: extras[k] })),

  finance_company: (extras) => [
    ["requests",  Wallet, "طلبات التمويل",    "Finance requests"],
    ["approved",  Wallet, "معتمَدة",           "Approved"],
    ["products",  Wallet, "المنتجات",          "Products"],
  ].map(([k, i, ar, en]) => ({ key: k, icon: i, ar, en, value: extras[k] })),

  inspection_center: (extras) => [
    ["bookings", Calendar, "الحجوزات",       "Bookings"],
    ["upcoming", Calendar, "قادمة",           "Upcoming"],
    ["reports",  Calendar, "التقارير",         "Reports"],
  ].map(([k, i, ar, en]) => ({ key: k, icon: i, ar, en, value: extras[k] })),

  workshop: (extras) => [
    ["work_orders", Wrench, "أوامر العمل",   "Work orders"],
    ["open_orders", Wrench, "مفتوحة",         "Open"],
    ["services",    Wrench, "الخدمات",        "Services"],
  ].map(([k, i, ar, en]) => ({ key: k, icon: i, ar, en, value: extras[k] })),

  auction_house: (extras) => [
    ["live_auctions",      Gavel, "مزادات نشطة",     "Live"],
    ["scheduled_auctions", Gavel, "مجدولة",           "Scheduled"],
    ["ended_auctions",     Gavel, "منتهية",           "Ended"],
  ].map(([k, i, ar, en]) => ({ key: k, icon: i, ar, en, value: extras[k] })),
};

CATEGORY_WIDGETS.periodic_inspection = CATEGORY_WIDGETS.inspection_center;

export default function DashCategoryPanel({ home }) {
  const { lang } = useI18n();
  const category = home?.business?.category;
  const extras = home?.category_extras || {};
  const widgetsFn = CATEGORY_WIDGETS[category];

  if (!widgetsFn) {
    return (
      <div className="rounded-2xl bg-white border border-dashed border-[#0a0a0a]/10 p-10 text-center text-[#8a8a8a]" data-testid="dash-category-empty">
        {lang === "ar"
          ? "ميزات مخصّصة لهذه الفئة ستُضاف قريبًا."
          : "Category-specific features coming soon."}
      </div>
    );
  }

  const widgets = widgetsFn(extras);
  return (
    <div className="space-y-6" data-testid="dash-category-panel">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4">
        {widgets.map((w) => (
          <KpiCard key={w.key} icon={w.icon} labelAr={w.ar} labelEn={w.en} value={w.value ?? 0} testid={`cat-kpi-${w.key}`} />
        ))}
      </div>
      <div className="rounded-2xl bg-white border border-dashed border-[#0a0a0a]/10 p-8 text-center text-[#8a8a8a] text-sm">
        {lang === "ar"
          ? "لوحات إدارة كاملة (حجوزات، أوامر عمل، منتجات...) ستُطلق في مرحلة قادمة. البنية والأرقام جاهزة الآن."
          : "Full management panels for this category ship in an upcoming phase. Infrastructure is ready."}
      </div>
    </div>
  );
}
